module.exports = __webpack_public_path__ + "img/pdf.cfb0d4a3.png";